import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import { ProfilMenuItem } from '../profilMenuItem';
import { AppBarSearch } from './appBarSearch';
import { ResetLayoutButton } from './resetLayoutButton';
import { FitToScreenButton } from './fitToScreenButton';
import { AddButton } from './AppBar/addButton';
import { MoreButton } from './AppBar/moreButton';
import { useState, useEffect } from 'react';

export const MyProjectAppBar = (props) => {

  const [isMobile, setIsMobile] = useState(false)

  //choose the screen size 
  const handleResize = () => {
    if (window.innerWidth < 720) {
      setIsMobile(true)
    } else {
      setIsMobile(false)
    }
  }

  // create an event listener
  useEffect(() => {
    window.addEventListener("resize", handleResize)
  })

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>
          <IconButton
            size="small"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
            onClick={() => { props.setProjectDrawerState(true) }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="a"
            // href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            NodeCanvas
          </Typography>
          <AppBarSearch elements={props.elements} canvasRef={props.canvasRef} />
          { !isMobile && <>
          <ResetLayoutButton action={() => props.canvasRef.current.setLayout()} />
          <FitToScreenButton action={() => props.canvasRef.current.Fit()} />
          </>
          }
          <AddButton selectedItem={props.selectedItem} canvasRef={props.canvasRef} />
          <MoreButton 
            selectedItem={props.selectedItem} 
            canvasRef={props.canvasRef} 
            isMobile={isMobile}
            actionResetLayout={() => props.canvasRef.current.setLayout()}
            actionFitToScreen={() => props.canvasRef.current.Fit()}
            />
          <ProfilMenuItem userData={props.userData}></ProfilMenuItem>
        </Toolbar>
      </AppBar>
    </Box>
  );
}